import type { DateRangePreset } from "nazare-ui/components";

/** Presets shared by date-range filters with day-based URL values. */
export const DATE_RANGE_PRESETS = [
  { value: "24h", label: "Last 24 hours" },
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
] as const satisfies readonly DateRangePreset[];

export type DateRangePresetValue = (typeof DATE_RANGE_PRESETS)[number]["value"];
